import { Injectable } from '@angular/core';
import { ContextService } from 'src/app/services/context/context.service';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor(private contextService: ContextService) { }

  set<T>(item: string, value: T): void {
    this.setItem(item, JSON.stringify(value));
  }

  get<T>(item: string): T {
    return JSON.parse(this.getItem(item));
  }

  setForFiscal<T>(item: string, value: T): void {
    this.set<T>(`${this.contextService.fiscalId}_${item}`, value);
  }

  getForFiscal<T>(item: string): T {
    return this.get<T>(`${this.contextService.fiscalId}_${item}`);
  }

  private setItem(item: string, value: string): void {
    window.localStorage.setItem(item, value);
  }
  private getItem(item: string): string {
    return window.localStorage.getItem(item);
  }
}
